import React from "react"

const Input = props => (
  <div className="Checkbox">
    <input type="checkbox" className="InputField" value={props.filter} />
    <label className="InputLabel" for={props.filter}>
      {props.filter} {props.quantaty}
    </label>
  </div>
)

export default Input